import { render } from "./delete-social-post.vue?vue&type=template&id=33ae5b51&ts=true"
import script from "./delete-social-post.vue?vue&type=script&lang=ts"
export * from "./delete-social-post.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__